/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllocatedPremiumScheduleByContractResponseDto
 */
export interface AllocatedPremiumScheduleByContractResponseDto {
    /**
     * Pinnacle reference number
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    pinnacleRefNo: string;
    /**
     * Receipt number
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    receiptNo: string;
    /**
     * Payment date
     * @type {Date}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    paymentDate?: Date;
    /**
     * PPW due date
     * @type {Date}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    ppwDueDate: Date;
    /**
     * Share of premium signed
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    shareOfPremiumSigned: string;
    /**
     * GST on premium
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    gstOnPremium: string;
    /**
     * Ceding commission
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    cedingCommission: string;
    /**
     * GST on ceding commission
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    gstOnCedingCommission: string;
    /**
     * Source brokerage
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    sourceBrokerage: string;
    /**
     * GST on source brokerage
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    gstOnSourceBrokerage: string;
    /**
     * ERE (Earthquake and related expenses)
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    ere: string;
    /**
     * Withholding tax
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    withholdingTax: string;
    /**
     * Net premium due from broker
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    netPremiumDueFromBroker: string;
    /**
     * Pinnacle commission
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    pinnacleCommission: string;
    /**
     * AIT (Additional Insurance Tax)
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    ait: string;
    /**
     * Taxes and fees
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    taxesAndFees: string;
    /**
     * Binder cash remittance
     * @type {string}
     * @memberof AllocatedPremiumScheduleByContractResponseDto
     */
    binderCashRemittance: string;
}

/**
 * Check if a given object implements the AllocatedPremiumScheduleByContractResponseDto interface.
 */
export function instanceOfAllocatedPremiumScheduleByContractResponseDto(value: object): value is AllocatedPremiumScheduleByContractResponseDto {
    if (!('pinnacleRefNo' in value) || value['pinnacleRefNo'] === undefined) return false;
    if (!('receiptNo' in value) || value['receiptNo'] === undefined) return false;
    if (!('ppwDueDate' in value) || value['ppwDueDate'] === undefined) return false;
    if (!('shareOfPremiumSigned' in value) || value['shareOfPremiumSigned'] === undefined) return false;
    if (!('gstOnPremium' in value) || value['gstOnPremium'] === undefined) return false;
    if (!('cedingCommission' in value) || value['cedingCommission'] === undefined) return false;
    if (!('gstOnCedingCommission' in value) || value['gstOnCedingCommission'] === undefined) return false;
    if (!('sourceBrokerage' in value) || value['sourceBrokerage'] === undefined) return false;
    if (!('gstOnSourceBrokerage' in value) || value['gstOnSourceBrokerage'] === undefined) return false;
    if (!('ere' in value) || value['ere'] === undefined) return false;
    if (!('withholdingTax' in value) || value['withholdingTax'] === undefined) return false;
    if (!('netPremiumDueFromBroker' in value) || value['netPremiumDueFromBroker'] === undefined) return false;
    if (!('pinnacleCommission' in value) || value['pinnacleCommission'] === undefined) return false;
    if (!('ait' in value) || value['ait'] === undefined) return false;
    if (!('taxesAndFees' in value) || value['taxesAndFees'] === undefined) return false;
    if (!('binderCashRemittance' in value) || value['binderCashRemittance'] === undefined) return false;
    return true;
}

export function AllocatedPremiumScheduleByContractResponseDtoFromJSON(json: any): AllocatedPremiumScheduleByContractResponseDto {
    return AllocatedPremiumScheduleByContractResponseDtoFromJSONTyped(json, false);
}

export function AllocatedPremiumScheduleByContractResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocatedPremiumScheduleByContractResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pinnacleRefNo': json['pinnacleRefNo'],
        'receiptNo': json['receiptNo'],
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'ppwDueDate': (new Date(json['ppwDueDate'])),
        'shareOfPremiumSigned': json['shareOfPremiumSigned'],
        'gstOnPremium': json['gstOnPremium'],
        'cedingCommission': json['cedingCommission'],
        'gstOnCedingCommission': json['gstOnCedingCommission'],
        'sourceBrokerage': json['sourceBrokerage'],
        'gstOnSourceBrokerage': json['gstOnSourceBrokerage'],
        'ere': json['ere'],
        'withholdingTax': json['withholdingTax'],
        'netPremiumDueFromBroker': json['netPremiumDueFromBroker'],
        'pinnacleCommission': json['pinnacleCommission'],
        'ait': json['ait'],
        'taxesAndFees': json['taxesAndFees'],
        'binderCashRemittance': json['binderCashRemittance'],
    };
}

export function AllocatedPremiumScheduleByContractResponseDtoToJSON(json: any): AllocatedPremiumScheduleByContractResponseDto {
    return AllocatedPremiumScheduleByContractResponseDtoToJSONTyped(json, false);
}

export function AllocatedPremiumScheduleByContractResponseDtoToJSONTyped(value?: AllocatedPremiumScheduleByContractResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pinnacleRefNo': value['pinnacleRefNo'],
        'receiptNo': value['receiptNo'],
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate']).toISOString()),
        'ppwDueDate': ((value['ppwDueDate']).toISOString()),
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'gstOnPremium': value['gstOnPremium'],
        'cedingCommission': value['cedingCommission'],
        'gstOnCedingCommission': value['gstOnCedingCommission'],
        'sourceBrokerage': value['sourceBrokerage'],
        'gstOnSourceBrokerage': value['gstOnSourceBrokerage'],
        'ere': value['ere'],
        'withholdingTax': value['withholdingTax'],
        'netPremiumDueFromBroker': value['netPremiumDueFromBroker'],
        'pinnacleCommission': value['pinnacleCommission'],
        'ait': value['ait'],
        'taxesAndFees': value['taxesAndFees'],
        'binderCashRemittance': value['binderCashRemittance'],
    };
}

